/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
// import React, { useCallback, useEffect, useState } from 'react'

import { useEffect,useState } from 'react'
import { TransactionListTable } from './TransactionListTable'
import { Highlights } from './Highlight'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  ListsWidget26,
  EngageWidget10,
  StatisticsWidget5,
} from '../../../_metronic/partials/widgets'
import {getDashboardList }from '../../services/DashboardService'
import { currentUser } from '../../services/AuthService'
import { useNavigate } from 'react-router-dom'
import { Charts } from '../../modules/widgets/components/Charts'
import { Feeds } from '../../modules/widgets/components/Feeds'
import { Lists } from '../../modules/widgets/components/Lists'
import { Mixed } from '../../modules/widgets/components/Mixed'
import { Statistics } from '../../modules/widgets/components/Statistics'
import { Tables } from '../../modules/widgets/components/Tables'
import WidgetsPage from '../../modules/widgets/WidgetsPage'

// import {Chart as } from "chart.js/auto/auto";
import { CategoryScale } from 'chart.js'
import { Bar, Doughnut, Line } from 'react-chartjs-2'
import { useDispatch } from 'react-redux'
import { getCurrentUser } from '../../redux/slices/AuthSlices'

// ChartClass.register(CategoryScale);
 
const DashboardPage: FC = () => {
  const [dashboardData, setDashboardData] = useState<any>({})
  // const navigate = useNavigate()

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await getDashboardList()
        // console.log("Fetched dashboard data: ", response)
        const mainData = response?.data?.data?.data?.[0]
        setDashboardData(mainData)
      } catch (error) {
        console.error("Error fetching dashboard data: ", error)
      }
    }
  
    fetchDashboardData()
  }, [])
  const jsonData = [
    {
      id: 2,
      svgIcon: 'people',
      color: 'card-primary',
      iconColor: 'white',
      title: dashboardData?.total_users,
      titleColor: 'black',
      description: 'Users',
      descriptionColor: 'black',
      onClick: () => navigate(`/setting/user`),
    },
    {
      id: 3,
      svgIcon: 'cheque',
      color: 'card-primary',
      iconColor: 'white',
      title: dashboardData?.total_transactions,
      titleColor: 'black',
      description: 'Transactions',
      descriptionColor: 'black',
      onClick: () => navigate(`/customized-form`),
    },
    {
      id: 4,
      svgIcon: 'fasten',
      color: 'card-primary',
      iconColor: 'white',
      title: dashboardData?.total_Roles,
      titleColor: 'black',
      description: 'Roles',
      descriptionColor: 'black',
      onClick: () => navigate(`/setting/role`),
    },
    {
      id: 5,
      svgIcon: 'share',
      color: 'card-primary',
      iconColor: 'white',
      title: dashboardData?.total_groups,
      titleColor: 'black',
      description: 'Groups',
      descriptionColor: 'black',
      onClick: () => navigate(`/setting/group`),
    },
  ]

  let user_details_string: any = localStorage.getItem('currentUser')
  const user_details: any = JSON.parse(user_details_string)
  const name: any = user_details?.name

  const data = {
    labels: ['Fund', 'Profit', 'Loss'],
    // datasets is an array of objects where each object represents a set of data to display corresponding to the labels above. for brevity, we'll keep it at one object
    datasets: [
      {
        label: 'Amount of transaction',
        data: [55, 23, 96],
        // you can set indiviual colors for each bar
        backgroundColor: ['rgba(93,70,201, 0.6)', '#fff', '#F0EEFD'],
        borderWidth: 1,
        width: 200,
        height: 200,
      },
    ],
  }

  const labels = ['js', 'js', 'js', 'js', 'js', 'js', 'js']
  const lineData = {
    labels: labels,
    datasets: [
      {
        label: 'My First Dataset',
        data: [65, 59, 80, 81, 56, 55, 40],
        fill: false,
        borderColor: 'rgb(75, 192, 192)',
        tension: 0.1,
      },
    ],
  }

  const navigate = useNavigate()
  return (
    <div>
      <div
        className='bg-card-primary mb-4 rounded px-4 py-4 d-flex justify-content-between'
        style={{ width: '100%', height: '160px' }}
      >
        <div
          className='d-flex flex-column justify-content-center align-item-center text-white'
          style={{ height: '150px' }}
        >
          <h1 className='text-black display-4 fw-normal'>Hello {name},</h1>
          <h6 className='text-black fw-bolder'>Welcome to AutomateBox!</h6>
        </div>
        <div style={{ width: '180px', margin: '-10px 0' }}>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/features-logos/dashboard_icon1.png')}
            className='w-100 h-140px app-sidebar-logo-default theme-light-show'
          />
        </div>
      </div>
      <div className='row g-5 g-xl-8'>
        {jsonData.map((item: any) => (
          <div key={item.id} className='col-xl-3' onClick={item.onClick}>
            <StatisticsWidget5
              className={`card-xl-stretch mb-xl-8 bg-${item.color}`}
              svgIcon={item.svgIcon}
              color={item.color}
              iconColor={item.iconColor}
              title={item.title}
              titleColor={item.titleColor}
              description={item.description}
              descriptionColor={item.descriptionColor}
            />
          </div>
        ))}
      </div>

      <div>
        <TransactionListTable className='mb-5 mb-xl-8' />
        <div className='row g-5 g-xl-8'>
            <div className='col-xl-4'>
              {/* <Highlights className='card-xl-stretch mb-5 mb-xl-8' /> */}
            </div>
            </div>
      </div>

        {/* <Charts /> */}
        {/* <Feeds/> */}
        {/* <Lists/> */}
        {/* <Mixed/> */}
        {/* <Statistics/> */}
        {/* <Tables/> */}
        {/* <WidgetsPage/> */}
        {/* </div> */}
      </div>
      )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
      return (
      <>
        <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
        <DashboardPage />
      </>
      )
}

      export {DashboardWrapper}
